import { useState } from "react";

interface Location {
  latitude: number;
  longitude: number;
}

interface GeolocationHookResult {
  location: Location | null;
  error: string | null;
  loading: boolean;
  fetchLocation: () => Promise<void>;
}

const useGeolocation = (): GeolocationHookResult => {
  const [location, setLocation] = useState<Location | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchLocation = async () => {
    setLoading(true);
    setError(null); // Reset error on each fetch attempt

    return new Promise<void>((resolve) => {
      if (!navigator.geolocation) {
        window.alert("Geolocation is not supported by your browser.");
        setError("Geolocation is not supported by your browser.");
        setLoading(false);
        resolve();
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          setLoading(false);
          resolve();
        },
        (err) => {
          window.alert(err.message);
          setError(err.message);
          setLoading(false);
          resolve();
        }
      );
    });
  };

  return { location, error, loading, fetchLocation };
};

export default useGeolocation;
